(() => {
  const HISTORY_KEY = 'cc-adviser-v109:conversation';
  const WIDGET_STATE_KEY = 'cc-adviser-v109:widget-open';

  document.querySelectorAll('[data-virtual-adviser]').forEach((root) => {
    const form = root.querySelector('[data-adviser-form]');
    const input = root.querySelector('[data-adviser-input]');
    const messages = root.querySelector('[data-adviser-messages]');
    const submit = form?.querySelector('button[type="submit"]');
    const reset = root.querySelector('[data-adviser-reset]');
    const status = root.querySelector('[data-adviser-status]');
    const launcher = root.querySelector('[data-adviser-launcher]');
    const panel = root.querySelector('[data-adviser-panel]');
    const close = root.querySelector('[data-adviser-close]');
    const humanButtons = root.querySelectorAll('[data-adviser-human]');
    const endpoint = root.dataset.endpoint?.trim();
    let history = readHistory();
    let pending = false;

    if (!form || !input || !messages || !submit) return;

    function readHistory() {
      try {
        const parsed = JSON.parse(sessionStorage.getItem(HISTORY_KEY) || '[]');
        return Array.isArray(parsed) ? parsed.slice(-12) : [];
      } catch {
        return [];
      }
    }

    function saveHistory() {
      try {
        sessionStorage.setItem(HISTORY_KEY, JSON.stringify(history.slice(-12)));
      } catch {
        // La conversation reste utilisable même si sessionStorage est bloqué.
      }
    }

    function scrollToLatest() {
      window.requestAnimationFrame(() => {
        messages.scrollTop = messages.scrollHeight;
      });
    }

    function appendInlineMarkdown(container, text) {
      const fragments = text.split(/(\*\*[^*]+\*\*)/g);
      fragments.forEach((fragment) => {
        if (fragment.startsWith('**') && fragment.endsWith('**') && fragment.length > 4) {
          const strong = document.createElement('strong');
          strong.textContent = fragment.slice(2, -2);
          container.appendChild(strong);
        } else if (fragment) {
          container.appendChild(document.createTextNode(fragment));
        }
      });
    }

    function renderMessage(container, text) {
      container.replaceChildren();
      const lines = String(text || '').replace(/\r/g, '').split('\n');
      let list = null;

      lines.forEach((rawLine) => {
        const line = rawLine.trim();
        if (!line) {
          list = null;
          return;
        }

        const bullet = line.match(/^[-•]\s+(.+)/);
        if (bullet) {
          if (!list) {
            list = document.createElement('ul');
            container.appendChild(list);
          }
          const item = document.createElement('li');
          appendInlineMarkdown(item, bullet[1]);
          list.appendChild(item);
          return;
        }

        list = null;
        const heading = line.match(/^#{1,3}\s+(.+)/);
        const paragraph = document.createElement(heading ? 'h3' : 'p');
        appendInlineMarkdown(paragraph, heading ? heading[1] : line);
        container.appendChild(paragraph);
      });
    }

    function createMessage(text, role, loading = false) {
      const item = document.createElement('div');
      item.className = `cc-adviser__message cc-adviser__message--${role}${loading ? ' cc-adviser__message--loading' : ''}`;

      if (role === 'assistant') {
        const avatar = document.createElement('div');
        avatar.className = 'cc-adviser__message-avatar';
        avatar.setAttribute('aria-hidden', 'true');
        avatar.textContent = 'CC';
        item.appendChild(avatar);
      }

      const bubble = document.createElement('div');
      bubble.className = 'cc-adviser__message-bubble';
      renderMessage(bubble, text);
      item.appendChild(bubble);
      messages.appendChild(item);
      scrollToLatest();

      return {
        item,
        setText(value) {
          renderMessage(bubble, value);
          scrollToLatest();
        }
      };
    }

    function addSources(container, sources) {
      if (!Array.isArray(sources) || !sources.length) return;
      const wrapper = document.createElement('div');
      wrapper.className = 'cc-adviser__sources';

      const list = document.createElement('div');
      sources.slice(0, 4).forEach((source) => {
        if (!source?.url || !source?.title) return;
        const link = document.createElement('a');
        link.href = source.url;
        link.className = 'cc-adviser__source';
        link.textContent = source.title;
        link.target = '_blank';
        link.rel = 'noopener';
        list.appendChild(link);
      });
      wrapper.appendChild(list);
      container.appendChild(wrapper);
      scrollToLatest();
    }

    function track(type) {
      if (!endpoint) return;
      const eventsEndpoint = endpoint.replace(/\/api\/adviser\/?$/, '/api/events');
      fetch(eventsEndpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        mode: 'cors',
        credentials: 'omit',
        keepalive: true,
        body: JSON.stringify({ type })
      }).catch(() => {});
    }

    function addChoices(container, choices) {
      if (!Array.isArray(choices) || !choices.length) return;
      const wrapper = document.createElement('div');
      wrapper.className = 'cc-adviser__choices';
      choices.slice(0, 4).forEach((choice) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.textContent = choice;
        button.addEventListener('click', () => send(choice));
        wrapper.appendChild(button);
      });
      container.appendChild(wrapper);
    }

    function addHuman(container, url = '/pages/contact') {
      const link = document.createElement('a');
      link.className = 'cc-adviser__human-link';
      link.href = url;
      link.textContent = 'Parler à un conseiller';
      link.addEventListener('click', () => track('human_transfers'));
      container.appendChild(link);
    }

    function addProducts(container, products) {
      if (!Array.isArray(products) || !products.length) return;
      const grid = document.createElement('div');
      grid.className = 'cc-adviser__products';
      products.slice(0, 3).forEach((product) => {
        const card = document.createElement('article');
        card.className = 'cc-adviser__product';
        if (product.image) {
          const image = document.createElement('img');
          image.src = product.image;
          image.alt = product.title || '';
          image.loading = 'lazy';
          image.width = 160;
          image.height = 160;
          card.appendChild(image);
        }
        const body = document.createElement('div');
        const title = document.createElement('strong');
        title.textContent = product.title || 'Produit CLASS’CLOPE';
        body.appendChild(title);
        const meta = document.createElement('p');
        const stock = product.available === true ? 'En stock' : product.available === false ? 'Épuisé' : 'Stock à confirmer';
        meta.textContent = [product.price, stock].filter(Boolean).join(' · ');
        meta.className = product.available === false ? 'is-unavailable' : '';
        body.appendChild(meta);
        if (product.variants?.length) {
          const variants = document.createElement('small');
          variants.textContent = product.variants.filter((variant) => variant.available !== false).map((variant) => variant.title).slice(0, 4).join(' · ');
          body.appendChild(variants);
        }
        if (product.why) {
          const why = document.createElement('p');
          why.innerHTML = '<b>Pourquoi il vous correspond :</b> ';
          why.appendChild(document.createTextNode(product.why));
          body.appendChild(why);
        }
        const link = document.createElement('a');
        link.href = product.url;
        link.textContent = 'Voir le produit';
        link.addEventListener('click', () => track('product_clicks'));
        body.appendChild(link);
        card.appendChild(body);
        grid.appendChild(card);
      });
      container.appendChild(grid);
    }

    function setBusy(value) {
      pending = value;
      submit.disabled = value;
      input.disabled = value;
      root.classList.toggle('cc-adviser--busy', value);
      if (!value) input.focus();
    }

    function localReply(message) {
      const normalized = message.toLocaleLowerCase('fr');
      if (normalized.includes('compatible') || normalized.includes('compatibilité')) {
        return 'Indiquez-moi la marque et le nom exact de votre matériel. Le véritable agent IA n’est pas encore connecté : je préfère ne confirmer aucune compatibilité sans vérification.';
      }
      if (normalized.includes('commande') || normalized.includes('livraison') || normalized.includes('retour')) {
        return 'Pour une commande, utilisez le canal de contact sécurisé CLASS’CLOPE. Ne partagez aucune donnée personnelle dans ce chat.';
      }
      return 'Le mode IA sécurisé n’est pas encore connecté. Renseignez l’adresse du serveur dans les paramètres de cette section pour activer les réponses personnalisées.';
    }

    async function consumeNdjson(response, assistantMessage) {
      if (!response.body) throw new Error('Flux indisponible');
      const reader = response.body.getReader();
      const decoder = new TextDecoder();
      let buffer = '';
      let answer = '';
      let sources = [];
      let products = [];
      let choices = [];
      let humanUrl = '';
      let responseIntent = 'information';

      while (true) {
        const { value, done } = await reader.read();
        if (done) break;
        buffer += decoder.decode(value, { stream: true });
        const lines = buffer.split('\n');
        buffer = lines.pop() || '';

        for (const line of lines) {
          if (!line.trim()) continue;
          const event = JSON.parse(line);
          if (event.type === 'sources') sources = event.items || [];
          if (event.type === 'products') products = event.items || [];
          if (event.type === 'verification') responseIntent = event.intent || 'information';
          if (event.type === 'choices') choices = event.items || [];
          if (event.type === 'human') humanUrl = event.url || '/pages/contact';
          if (event.type === 'delta') {
            answer += event.delta || '';
            assistantMessage.item.classList.remove('cc-adviser__message--loading');
            assistantMessage.setText(answer);
          }
          if (event.type === 'error') throw new Error(event.message || 'Erreur du conseiller');
        }
      }

      if (!answer.trim()) throw new Error('Réponse vide');
      const bubble = assistantMessage.item.querySelector('.cc-adviser__message-bubble');
      if (['recommendation', 'compatibility'].includes(responseIntent)) addProducts(bubble, products);
      addChoices(bubble, choices);
      if (humanUrl) addHuman(bubble, humanUrl);
      if (!['troubleshooting', 'safety', 'health'].includes(responseIntent)) addSources(bubble, sources);
      return answer.trim();
    }

    async function send(message) {
      if (pending) return;
      createMessage(message, 'user');
      setBusy(true);
      const assistantMessage = createMessage('Un instant, je prépare votre réponse…', 'assistant', true);

      try {
        let answer;
        if (endpoint) {
          const response = await fetch(endpoint, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/x-ndjson'
            },
            mode: 'cors',
            credentials: 'omit',
            body: JSON.stringify({
              message,
              history: history.slice(-12),
              page_url: window.location.href,
              shop: root.dataset.shopName || ''
            })
          });

          if (!response.ok) {
            const payload = await response.json().catch(() => ({}));
            throw new Error(payload.error || `HTTP ${response.status}`);
          }
          answer = await consumeNdjson(response, assistantMessage);
        } else {
          answer = localReply(message);
          assistantMessage.item.classList.remove('cc-adviser__message--loading');
          assistantMessage.setText(answer);
        }

        history.push({ role: 'user', content: message }, { role: 'assistant', content: answer });
        history = history.slice(-12);
        saveHistory();
      } catch (error) {
        track('errors');
        assistantMessage.item.classList.remove('cc-adviser__message--loading');
        assistantMessage.setText(
          'Le conseiller rencontre momentanément un problème de connexion. Réessayez dans un instant ou contactez directement l’équipe CLASS’CLOPE.'
        );
      } finally {
        setBusy(false);
      }
    }

    function restoreConversation() {
      if (!history.length) return;
      messages.querySelectorAll('[data-restored]').forEach((item) => item.remove());
      history.forEach((entry) => {
        const message = createMessage(entry.content, entry.role);
        message.item.dataset.restored = 'true';
      });
      if (status) status.textContent = 'Conversation reprise';
    }

    function setPanelOpen(open, focusInput = false) {
      if (!panel || !launcher) return;
      panel.hidden = !open;
      launcher.setAttribute('aria-expanded', String(open));
      root.classList.toggle('cc-adviser-float--open', open);
      try {
        localStorage.setItem(WIDGET_STATE_KEY, open ? '1' : '0');
      } catch {
        // Le bouton reste utilisable même si localStorage est bloqué.
      }
      if (open && focusInput) window.requestAnimationFrame(() => input.focus());
    }

    if (panel && launcher) {
      let shouldOpen = false;
      try {
        shouldOpen = localStorage.getItem(WIDGET_STATE_KEY) === '1';
      } catch {
        // Le mini-chat démarre fermé si localStorage est bloqué.
      }
      panel.hidden = !shouldOpen;
      launcher.setAttribute('aria-expanded', String(shouldOpen));
      root.classList.toggle('cc-adviser-float--open', shouldOpen);
      launcher.addEventListener('click', () => setPanelOpen(panel.hidden, true));
      close?.addEventListener('click', () => {
        setPanelOpen(false);
        launcher.focus();
      });
      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && !panel.hidden) {
          setPanelOpen(false);
          launcher.focus();
        }
      });
    }

    form.addEventListener('submit', (event) => {
      event.preventDefault();
      const message = input.value.trim();
      if (!message) return;
      input.value = '';
      input.style.height = '';
      send(message);
    });

    input.addEventListener('keydown', (event) => {
      if (event.key === 'Enter' && !event.shiftKey) {
        event.preventDefault();
        form.requestSubmit();
      }
    });

    input.addEventListener('input', () => {
      input.style.height = 'auto';
      input.style.height = `${Math.min(input.scrollHeight, 140)}px`;
    });

    root.querySelectorAll('[data-adviser-prompt]').forEach((button) => {
      button.addEventListener('click', () => {
        const prompt = button.dataset.adviserPrompt?.trim();
        if (prompt) send(prompt);
      });
    });

    root.querySelectorAll('[data-adviser-open-selector]').forEach((button) => {
      button.addEventListener('click', () => {
        track('guided_selector_opens');
        window.location.href = '/pages/selecteur-guide';
      });
    });

    humanButtons.forEach((button) => {
      button.addEventListener('click', () => track('human_transfers'));
    });

    reset?.addEventListener('click', () => {
      history = [];
      saveHistory();
      messages.querySelectorAll('.cc-adviser__message').forEach((item, index) => {
        if (index > 0) item.remove();
      });
      if (status) status.textContent = endpoint ? 'En ligne' : 'Mode guidé';
      input.focus();
    });

    restoreConversation();

    if (new URLSearchParams(window.location.search).get('cc_selector') === '1') {
      try {
        const selectorContext = JSON.parse(sessionStorage.getItem('cc-selector:adviser-context') || 'null');
        if (selectorContext?.source === 'selecteur-guide') {
          sessionStorage.removeItem('cc-selector:adviser-context');
          const answerLines = Object.entries(selectorContext.answers || {})
            .map(([key, value]) => `${key}: ${Array.isArray(value) ? value.join(', ') : value}`)
            .join(' ; ');
          const productLines = (selectorContext.products || []).map((product) => product.title).join(', ');
          const packLines = (selectorContext.pack || []).map((product) => product.title).join(', ');
          const contextMessage = [
            selectorContext.prompt,
            `Parcours : ${selectorContext.path || 'non précisé'}.`,
            answerLines ? `Réponses : ${answerLines}.` : '',
            productLines ? `Produits recommandés : ${productLines}.` : '',
            packLines ? `Pack préparé : ${packLines}.` : ''
          ].filter(Boolean).join('\n');
          window.requestAnimationFrame(() => send(contextMessage));
        }
      } catch {
        // Le conseiller reste disponible même si le contexte temporaire est indisponible.
      }
    }
  });
})();
